export const sizeMapping = {
  '40px': '48px',
  '55px': '56px',
  '70px': '64px'
};

export const labelSizeMapping = {
  '40px': '1.2em',
  '55px': '1.4em',
  '70px': '1.6em'
};
